import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { JpmamJobsTable } from '../../../../../../../../../../features/vendor/jpmam/job/jpmam-jobs-table';
import { JpmamVendorTabRail } from '../../../../../../../../../../features/vendor/jpmam/jpmam-vendor-tab-rail';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorJpmam,
      label: 'Jobs',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorJpmam>,
  head: () => getPageHead('JPMAM Jobs'),
  component: JpmamJobList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <JpmamVendorTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
      />
    </VerticalStack>
  );
}

function JpmamJobList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <JpmamJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
